export const FAILURE_FLAGS_BASE_URL = '/failure-flags'

export function getFailureFlagsUrls() {
  return {
    application: (applicationName: string) =>
      `${FAILURE_FLAGS_BASE_URL}/application/${applicationName}`,
    experiment: (experimentName: string) =>
      `${FAILURE_FLAGS_BASE_URL}/experiment/${experimentName}`,
    flag: (flagName: string) => `${FAILURE_FLAGS_BASE_URL}/flags/${flagName}`,
    gettingStarted: () => `${FAILURE_FLAGS_BASE_URL}/getting-started`,
    homeTab: (tabName: 'list' | 'getting-started') =>
      `${FAILURE_FLAGS_BASE_URL}/${tabName}`,
    list: () => `${FAILURE_FLAGS_BASE_URL}/list`,
    new: () => `${FAILURE_FLAGS_BASE_URL}/new`
  }
}
